import React from "react";

const DiscriptionTab = ({ Descripe = "", benefits = [] }) => {
  return (
    <div className="App-header ">
      {Descripe !== "" ? (
        <>
          {" "}
          <p className="space-y-3 list-disc   text-sm text-gray-800">
            {Descripe}
          </p>
          <br />
        </>
      ) : (
        <></>
      )}

      {benefits.length > 0 ? (
        <div className="mt-5">
          <h3 className="text-[20px] font-[500] text-gray-800 text-left">
            Benefits:
          </h3>
          <ul className="space-y-3 list-disc list-inside mt-4 pl-4 text-sm text-gray-800">
            {benefits.map((benefit, index) => (
                <li className="text-left mb-2" key={index}>
                  {benefit}
                </li>
            ))}
          </ul>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DiscriptionTab;
